module.exports = window.Sentry;